import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import env from "../../config/env";
import { useSelector } from "react-redux";
import CryptoJS from "crypto-js";

const SECRET_KEY = env.REACT_APP_ENCRYPTION_KEY;

export const fetchRoleData = createAsyncThunk("fetchRoleData", async (token) => {
  // const token = useSelector((state) => state.auth.token);

  const getRole = CryptoJS.SHA256("/getRole" + SECRET_KEY).toString(CryptoJS.enc.Hex).substring(0, 12); // Shorten for readability

  const response = await fetch(
    `${env.backend_api_endpoint}/${getRole}`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        authorization: token,
      },
    }
  );

  const resData = await response.json();

  if (resData?.data) {
    try {
      const bytes = CryptoJS.AES.decrypt(resData.data, SECRET_KEY);
      const decrypted = bytes.toString(CryptoJS.enc.Utf8);
      resData.data = JSON.parse(decrypted); // ✅ replace encrypted data with decrypted JSON
    } catch (err) {
      console.error("Decryption error:", err);
      resData.data = null; // fallback if decryption fails
    }
  }

  console.log(resData,"hgjhgvjhw")

  // ✅ Return the full response (status, message, and decrypted data)
  return resData;
});

const roleDataSlice = createSlice({
  name: "getRole",
  initialState: {
    isLoading: false,
    data: null,
    isError: false,
  },
  extraReducers: async (builder) => {
    builder.addCase(fetchRoleData.pending, (state, action) => {
      state.isLoading = true;
    });
    await builder.addCase(fetchRoleData.fulfilled, (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    });
    builder.addCase(fetchRoleData.rejected, (state, action) => {
      state.isError = true;
    });
  },
});

export default roleDataSlice.reducer;
